import { window } from "global";
import React, { useState, useEffect, useMemo } from "react";
import classnames from "classnames";
import { getSummonerProfileContext } from "components/SummonerProfiles/SummonerProfileContext";
import Modal from "components/Modal";
import { getUrl } from "@outplayed/riot-assets";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import { useSummonerProfile, updateProfileCustomizations } from "api/summonerProfileApi";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { ReactComponent as IconX } from "svg/x.svg";
import { ReactComponent as SearchIcon } from "svg/search-icon.svg";
import { ReactComponent as CheckboxIcon } from "svg/checkbox.svg";

const ThumbnailImage = (props) => {
  const { imgSrc } = props;
  const [imageLoaded, setImageLoaded] = useState("");
  const isLoaded = imgSrc === imageLoaded;
  return (
    <div className="thumbnail-holder">
      <img
        style={{ display: isLoaded ? "" : "none" }}
        className="champ-thumbnail"
        src={imgSrc}
        onLoad={() => setImageLoaded(imgSrc)}
      />
      {!isLoaded && (
        <div className="spinthatshit-loader">
          <div className="spinner" />
        </div>
      )}
    </div>
  );
};

const ProfileBackgroundModal = (props) => {
  const { useChampionFull, getChampionIdByName, getChampionSplashImg } = getRiotAssetsContext();
  const context = getSummonerProfileContext();
  const { summonerName, region, setIsModalOpen } = context;
  const { loading: loadingProfileInit, data: profileInitData } = useSummonerProfile(region, summonerName, {}, null);
  const { customizationData } = (profileInitData && profileInitData.profileInit) || {};

  const [buttonText, setButtonText] = useState("Save Changes");
  const [filterText, setFilterText] = useState("");
  const [chosenSkin, setChosenSkin] = useState(customizationData?.headerBg);
  const { data: championFull, loading: loadingChampionFull } = useChampionFull();
  const [setHeaderBg, { data, loading }] = updateProfileCustomizations({ headerBg: chosenSkin });

  const findDefaultChampionIndex = () => {
    const champName = customizationData && customizationData.headerBg?.split("_")[0];
    return getChampionIdByName(champName) || 1;
  };
  const [chosenChampIndex, setChosenChampIndex] = useState(findDefaultChampionIndex());

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const champData = championFull || {};
  if (chosenChampIndex === -1 && chosenChampIndex !== findDefaultChampionIndex()) {
    setChosenChampIndex(findDefaultChampionIndex());
  }

  const clickChamp = (champName) => {
    setChosenChampIndex(getChampionIdByName(champName));
    setButtonText("Save Changes");
    document.getElementById("champion-skin-selection").scrollTop = 0;
  };

  // const navToSocialModal = () => {
  //   props.swapModal("socialModal");
  // }

  const filteredChamps = useMemo(() => {
    if (!champData) return [];
    const list = Object.values(champData)
      .filter((champion) => {
        return champion.skins && (filterText === "" || champion.id.toLowerCase().includes(filterText));
      })
      .sort((a, b) => a.name.localeCompare(b.name));

    return list;
  }, [champData, filterText]);

  useEffect(() => {
    if (window) {
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = "inherit";
      };
    }
  }, []);

  useEffect(() => {
    if (data) {
      setIsModalOpen(false);
    }
  }, [data]);

  return (
    <Modal disableTooltip={true} isFixed={true} bModalOpen={true} bDisableFooter={true}>
      <div className="profile-customizations">
        <div className="background" />
        <div className="customizations-modal large">
          <div className="backgrounds-modal">
            <div className="exit-row">
              {/*<div className="back-text" onClick={navToSocialModal}>{"<"} Back</div>*/}
              <div className="close-container">
                <IconX className="close-button" onClick={closeModal} />
              </div>
            </div>
            <div className="header-row">Select New Header Background</div>
            <div className="main-content-row">
              <div className="col1-container">
                <div className="champion-search-box">
                  <input
                    type="text"
                    placeholder="Search Champion"
                    onChange={(e) => setFilterText(e.target.value.toLowerCase())}
                  />
                  <SearchIcon className="search-icon" />
                </div>
                <div className="champ-name-list">
                  {filteredChamps &&
                    Object.values(filteredChamps).map((champion, index) => {
                      return (
                        <div
                          className={`champ-name-entry ${champion.key === chosenChampIndex ? "chosen" : ""}`}
                          key={index}
                          onClick={() => clickChamp(champion.id)}
                        >
                          {champion.name}
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="col2-container">
                <div id="champion-skin-selection" className="thumbnails">
                  {champData[chosenChampIndex] &&
                    champData[chosenChampIndex].skins.map((skin, index) => {
                      const champName = champData[chosenChampIndex].id;
                      const { num, name } = skin;
                      const imgSrc = getChampionSplashImg(champData[chosenChampIndex].key, { splashId: num });
                      const selectedClass = chosenSkin === `${champName}_${num}` ? "isSelected" : "";

                      return (
                        <div key={index}>
                          <div
                            className="thumbnail-container"
                            onClick={() => {
                              setChosenSkin(`${champName}_${num}`);
                              setButtonText("Save Changes");
                            }}
                          >
                            <ThumbnailImage imgSrc={imgSrc} />
                            <div className={`tint-layer ${selectedClass}`} />
                            {selectedClass === "isSelected" && <CheckboxIcon className="checkmark" />}
                          </div>
                          <div className={`champion-skin-name ${selectedClass}`}>{name === "default" ? champName : name}</div>
                        </div>
                      );
                    })}
                </div>
                <div className="save-container">
                  <div className="clear-header" onClick={() => setChosenSkin("")}>
                    Clear Current Header
                  </div>
                  <ButtonSuccess
                    className="btn-blue save-button"
                    label="Save Changes"
                    onClick={setHeaderBg}
                    isLoading={loading}
                    success={data}
                    bForceSubmitOnEnter={true}
                    disable={buttonText === "Saved!"}
                    style={buttonText === "Saved!" ? { background: "grey" } : {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ProfileBackgroundModal;
